import React, { useState } from "react";
import { METRIC_BANDS, DEFAULT_VISIBLE_BANDS, ScenarioColumnPicker } from "./columnPickerShared";

export default function CompareForecastVersionsTab({
  classes, ContractTable,
  cfTotal, cfRows,
  rightTotal, rightRows,
  varTotal, varRows,
  actualColumns, rightActualColumns, actualThroughMonth, rightActualThroughMonth,
  leftVersion, rightVersionMeta,
  fiscalYear,
  versions, rightVersion, onVersionChange,
  fmtVar, periodMonthKeys,
}) {
  const [visibleBands, setVisibleBands] = useState(DEFAULT_VISIBLE_BANDS);

  const toggle = (key) =>
    setVisibleBands((prev) =>
      prev.includes(key)
        ? prev.length > 1 ? prev.filter((k) => k !== key) : prev
        : [...prev, key].sort((a, b) =>
            METRIC_BANDS.findIndex((m) => m.key === a) - METRIC_BANDS.findIndex((m) => m.key === b))
    );

  const fy = fiscalYear ? ` FY-${fiscalYear}` : "";
  const year = String(fiscalYear || "");
  const leftName  = leftVersion?.name  || "Live EAC";
  const rightName = rightVersionMeta?.name || (versions.find((v) => v.key === rightVersion)?.name) || rightVersion || "Selected Version";

  const leftTitle  = `Current Month Actuals + ${leftName} Forecast${fy}`;
  const rightTitle = `Current Month Actuals + Forecast ${rightName}${fy}`;

  const leftActualProps = { actualColumns, actualThroughMonth };
  /* rightActualThroughMonth is authoritative for the right/selected-version table —
     a value of 0 means that version has no actuals, so no fallback to the left
     table's actualColumns/actualThroughMonth. */
  const rightActualProps = {
    actualColumns: rightActualColumns || [],
    actualThroughMonth: rightActualThroughMonth,
  };

  const controls = (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <div className={classes.filterGroup}>
        <span className={classes.filterLabel}>Version</span>
        <select
          className={classes.filterSelect}
          value={rightVersion || ""}
          onChange={(e) => onVersionChange(e.target.value)}
        >
          {versions.length === 0 ? (
            <option value="">Loading...</option>
          ) : (
            versions.map((v) => (
              <option key={v.key} value={v.key}>{v.name}</option>
            ))
          )}
        </select>
      </div>
      <ScenarioColumnPicker visible={visibleBands} onToggle={toggle} />
    </div>
  );

  return (
    <div>
      <ContractTable
        title={leftTitle}
        subtitle={`${leftName} Scenario`}
        totalRow={cfTotal} rows={cfRows} year={year}
        classes={classes} visibleBands={visibleBands} controls={controls} periodMonthKeys={periodMonthKeys}
        {...leftActualProps}
      />
      <ContractTable
        title={rightTitle}
        subtitle={`${rightName} Forecast Scenario`}
        totalRow={rightTotal} rows={rightRows} year={year}
        classes={classes} visibleBands={visibleBands} periodMonthKeys={periodMonthKeys}
        {...rightActualProps}
      />
      <ContractTable
        title="Variance"
        subtitle={`${leftName} Vs ${rightName}`}
        totalRow={varTotal} rows={varRows} year={year}
        classes={classes} formatter={fmtVar} visibleBands={visibleBands} periodMonthKeys={periodMonthKeys}
        {...leftActualProps}
      />
    </div>
  );
}
